import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import DashboardLayout from './DashboardLayout';
import OrganizationManagement from './Organisations/OrganisationManagement';
import baseURL from '../config';
import PageLoader from '../../../Reusable/PageLoader';

const ManageOrgs = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrganizations = async () => {
      setLoading(true);
      setError(null);
      try {
        // Simulate a small delay for demo purposes, if needed
        // await new Promise(resolve => setTimeout(resolve, 4000));

        const response = await fetch(`${baseURL}/admin/organizations`, {
          method: 'GET',
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error('Failed to fetch organizations');
        }

        const data = await response.json();
        setOrganizations(data);
      } catch (err) {
        console.error(err);
        toast.error(err.message || "Something went wrong while loading organizations.");
        setError(err.message || "Something went wrong while loading organizations.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, []);

  return (
    <DashboardLayout>
      <Typography
        variant="h6"
        sx={{
          color: '#666',
          marginBottom: 2,
          textAlign: 'left',
          marginTop: 2,
          fontWeight: '600',
        }}
      >
        Manage Organisations
      </Typography>

      {/* Conditional rendering based on state */}
      {loading ? (
        <PageLoader message="Loading Organizations..." subtext="Fetching all organizations" />
      ) : error ? (
        <Box sx={{ p: 3, textAlign: 'center', mt: 4, color: '#D83B01' }}>
          <Typography variant="body1">
            Error: {error}
          </Typography>
        </Box>
      ) : (
        <OrganizationManagement organizations={organizations} />
      )}
    </DashboardLayout>
  );
};

export default ManageOrgs;